/* Transient result widgets. A widget is pushed ONLY from a real tool result (mail summary, calendar event,
   document preview, research result, map, news, music). The default screen stays clean — widgets appear on
   request / when there is visual content, and are closable/expandable. Same path for chat and Live. */
const EVT = "jarvis-widget";

// op: "add" | "close" | "clear"  · widget: {wid?, kind, title, data, big?}
export const widgetEmit = (op, widget = {}) =>
  window.dispatchEvent(new CustomEvent(EVT, { detail: { op, widget } }));
export const onWidget = (fn) => {
  const h = (e) => fn(e.detail || {});
  window.addEventListener(EVT, h);
  return () => window.removeEventListener(EVT, h);
};

// "big" widgets take the content area (orb moves to the corner); small cards keep the orb centred.
export const BIG_KINDS = new Set(["map", "document", "news"]);
